<template>
  <div class="modal animated is-active">
    <div class="modal-background"></div>
    <div class="modal-card is-large">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
      </header>
      <section class="modal-card-body">
        <div class="notification is-danger" v-if="error !== ''">{{ error }}</div>
        <p class="control">
          <label class="label">Payment</label>
          <select class="select is-fullwidth" v-model="provider.payment_type" name="payment_type" id="payment_type">
            <option value="1">Billed</option>
            <option value="2">Anticipated</option>
            <option value="3">Billed/Anticipated</option>
          </select>
        </p>
        <p class="control">
          <label class="label">Limit</label>
          <input class="input" type="text" name="limit" id="limit" placeholder="Limit" v-model="provider.limit">
        </p>
        <p class="control">
          <label class="label">Rule</label>
          <select :class="{'select': true, 'is-fullwidth': true}" v-model="provider.rule_id" name="rule" id="rule" :disabled="parseInt(context.$store.state.config.user.level) < 3">
            <option value="">None</option>
            <option v-for="rule in rules" v-bind:value="rule.id" v-if="rule.name.trim() != ''">{{ rule.name }}</option>
          </select>
        </p>
        <p class="control">
          <label class="label">Payment Bank</label>
          <select class="select is-fullwidth" v-model="provider.payment_bank" name="payment_bank" id="payment_bank">
            <option v-for="bank in context.$store.state.config.bank" v-bind:value="bank.id">{{ bank.name }}</option>
          </select>
        </p>
        <p class="control">
          <label class="label">Bank Data <a class="button is-small " @click="openProviderBankData"><i class="fa fa-plus"></i></a></label>
          <table class="table is-bordered is-striped is-narrow">
              <thead>
              <tr>
                  <th>Bank</th>
                  <th>SWIFT</th>
                  <th>Currency</th>
                  <th>Action</th>
              </tr>
              </thead>
              <tbody>
              <template v-if="bank_data.length > 0">
                  <tr v-for="bank in bank_data">
                    <td>{{bank.bank_name}}</td>
                    <td>{{bank.SWIFT}}</td>
                    <td>{{bank.currency}}</td>
                    <td style="text-align: center;">
                        <!-- <a class="button button-table is-small" @click="excludeBank(bank.id)">
                          <i class="fa fa-trash"></i>
                        </a> -->
                        <a class="button button-table is-small" @click="editBank(bank.id)">
                          <i class="fa fa-pencil"></i>
                        </a>
                        <a class="button button-table is-small" @click="print(bank.id)">
                          <i class="fa fa-print"></i>
                        </a>
                    </td>
                  </tr>
              </template>
              <template v-else>
                  <tr>
                  <td colspan="4" style="text-align: center;">No bank data</td>
                  </tr>
              </template>
              </tbody>
          </table>
        </p>
        <template v-if="provider.logo === '' || provider.logo === null">
          <p class="control is-expanded" >
            <label class="label">Logo</label>
            <input type="file" id="logo" ref="logo" v-on:change="handleFileUploadLogo()"/>
          </p>
        </template>
        <template v-else>
          <p class="control is-expanded" >
            <label class="label">Logo</label>
            <span>{{ provider.logo }} <a class="button is-small " @click="changeLogo"><i class="fa fa-refresh"></i></a></span>
          </p>
        </template>

      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a :class="{'button': true, 'is-primary': true, 'is-disabled': inProgress}" @click="close(true)">Close</a>
          </p>
          <p class="control">
            <a :class="{'button': true, 'is-success': true, 'is-loading': inProgress}" @click="save">Save</a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  import babelPolyfill from 'babel-polyfill'
  import Provider from './Provider'
  export default {
    props: {
      context: {
        type: Object
      },
      callback: {
        type: String
      },
      title: {
        type: String
      },
      provider_id: {
        type: Number
      }
    },
    data () {
      return {
        provider: {
          payment_type: 1,
          limit: 0,
          rule_id: 1
        },
        file: '',
        inProgress: false,
        error: '',
        rules: [],
        bank_data: []
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.loadData()
        this.loadRules()
        this.loadBankData()
      })
    },
    methods: {
      changeLogo () {
        this.provider.logo = ''
      },
      handleFileUploadLogo () {
        this.file = this.$refs.logo.files[0]
        this.error = ''
      },
      async submitFileLogo () {
        if (this.file !== null) {
          let data = new window.FormData()
          data.append('file', this.file)
          data.append('provider_id', this.provider_id)
          this.context.$http.post(this.context.$store.state.config.apiURL + '/providers/files/logo', data, {headers: {'Content-Type': 'multipart/form-data'}}).then((response) => {
            return true
          }, (response) => {
            return true
          })
        } else {
          return true
        }
      },
      close (closeOnly, result) {
        if (!closeOnly) {
          this.context[this.callback](result)
        }
        this.$el.remove()
      },
      print (id) {
        window.location.href = this.context.$store.state.config.apiURL + '/providers/bank_data/print/' + id
      },
      async save () {
        this.$validator.validateAll()
        await this.submitFileLogo()
        // if (this.$validator.errorBag.errors.length === 0) {
        this.inProgress = true
        this.error = ''
        this.context.$http.post(this.context.$store.state.config.apiURL + '/providers/payment/' + this.provider_id, this.provider).then((response) => {
          this.inProgress = false
          this.close(false, {ok: true, message: 'The Provider ' + response.body.name + ' was successfully save'})
        }, (response) => {
          this.inProgress = false
          this.error = response.body
        })
        // }
      },
      loadData () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/providers/' + this.provider_id).then((response) => {
          this.provider = response.body
          document.body.appendChild(this.$el)
        }, (response) => {
        })
      },
      loadRules () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/invoice_payment_rules/payment').then((response) => {
          this.rules = response.body
        }, (response) => {

        })
      },
      loadBankData () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/providers/bank_data/provider/' + this.provider_id).then((response) => {
          this.bank_data = response.body
        }, (response) => {

        })
      },
      editBank (id) {
        let propsData = {
          context: this.context,
          id: id,
          provider_id: this.provider.id,
          title: 'Bank Data - ' + this.provider.name,
          callback: 'providerCallback',
          parent: this
        }
        Provider.openProviderBankData(propsData)
      },
      openProviderBankData () {
        let propsData = {
          context: this.context,
          provider_id: this.provider.id,
          title: 'New Bank Data - ' + this.provider.name,
          callback: 'providerCallback',
          parent: this
        }
        Provider.openProviderBankData(propsData)
      },
      providerCallback () {
        this.loadBankData()
      }
    },
    components: {
      babelPolyfill
    },
    computed: {
      enterClass () {
        return `${this.transition}In`
      },
      leaveClass () {
        return `${this.transition}Out`
      }
    }
  }
</script>
<style lang="scss" scoped>
  .is-title {
    text-transform: capitalize;
  }

  .panel {
    background-color: white;
    box-shadow: 0px 2px 3px rgb(167, 28, 32), 0px 0px 0px 1px rgb(167, 28, 32);
    color: #4a4a4a;
    max-width: 100%;
    position: relative;
    border: 0px;
    border-radius: 0px;
  }

  .panel-heading {
    color: #FFFFFF;
    font-weight: bold;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: flex;
    min-height: 40px;
    box-shadow: 0px 1px 0px rgb(167, 28, 32), 0px 0px 0px 0px rgb(167, 28, 32);
    background-color: rgb(167, 28, 32);
    border-bottom: 0px;
    border-radius: 0px;
    font-size: 1rem;
  }
</style>



// WEBPACK FOOTER //
// ProviderFinances.vue?f7083538